import React from 'react'
import Footer from '../../../components/Footer'
import { Link } from 'react-router-dom';

const BachelorCommerce = () => {
  return (
    <div className='  w-full relative font-poppins ' >
        <div className=' w-10/12 mx-auto mt-[100px] md:mt-[150px] flex flex-col gap-5 md:gap-5 ' >
        <h2 className={` mb-4 text-2xl md:text-6xl tracking-tight font-bold text-center text-[#0e4d38] `}>Bachelor of Commerce – Hons. (B.Com. – Hons.)</h2>
        <div className=' w-[20%] mx-auto h-[6px] bg-[#23376c] mt-[-10px] md:mt-[-20px] ' ></div>
            <div className=' flex flex-col gap-8 mb-10 md:gap-[80px] mt-5 justify-center md:justify-between ' >
                <div className=' flex flex-col md:flex-row gap-8 md:gap-[80px] ' >
                        <div className=' flex flex-col gap-2 ' >
                            <h4 className=' font-bold text-xl md:text-2xl ' >Finance</h4>
                            <p className=' text-justify md:text-lg ' >A B. Com in Finance specialization provides a focused understanding of financial principles, preparing graduates for careers in finance, banking, and investment management. Through comprehensive coursework, students gain skills in financial analysis, investment decision-making, and corporate finance, positioning them to thrive in dynamic financial environments.</p>
                            {/* <Link to="https://admission.maya.edu.in/" >
                            <button className=' mt-5 md:mt-0 bg-[#23376c] px-4 py-2 text-white rounded-full font-semibold transition-all duration-200 hover:bg-[#4865b3] '
                            >Register Now</button>
                        </Link> */}
                        </div>
                </div>
                <div className=' w-[90%] mx-auto h-[2px] bg-[#23376c] mt-[-10px] md:mt-[-20px] ' ></div>
                <div className=' flex flex-col md:flex-row gap-8 md:gap-[80px] ' >
                        <div className=' flex flex-col gap-2 ' >
                            <h4 className=' font-bold text-xl md:text-2xl ' >Taxation</h4>
                            <p className=' text-justify md:text-lg ' >A B. Com with a specialization in Taxation offers students in-depth knowledge of tax laws and regulations, enabling them to navigate complex tax systems effectively. Graduates are equipped with the expertise to provide tax planning and compliance services for individuals and businesses, making them valuable assets in accounting firms, corporations, and government agencies. This specialization prepares students for careers as tax consultants, auditors, and tax analysts, contributing to the efficient management of tax liabilities for organizations and individuals.</p>
                            {/* <Link to="https://admission.maya.edu.in/" >
                            <button className=' mt-5 md:mt-0 bg-[#23376c] px-4 py-2 text-white rounded-full font-semibold transition-all duration-200 hover:bg-[#4865b3] '
                            >Register Now</button>
                        </Link> */}
                        </div>
                </div>
                <div className=' w-[90%] mx-auto h-[2px] bg-[#23376c] mt-[-10px] md:mt-[-20px] ' ></div>
                <div className=' flex flex-col md:flex-row gap-8 md:gap-[80px] ' >
                        <div className=' flex flex-col gap-2 ' >
                            <h4 className=' font-bold text-xl md:text-2xl ' >Accounting</h4>
                            <p className=' text-justify md:text-lg ' >A B. Com with a specialization in Accounting provides students with a comprehensive understanding of accounting principles, financial reporting standards, and auditing practices. Graduates are equipped to pursue careers as accountants, auditors, financial analysts, or controllers in various industries. This specialization emphasizes critical thinking, analytical skills, and attention to detail, preparing students to play essential roles in financial management and decision-making within organizations.</p>
                        </div>
                </div>

            </div>

            <div className=' flex flex-col gap-10 mt-5 mb-[50px] ' >
               <div className=' flex flex-col gap-2 ' >
                        <h4 className={` text-2xl font-semibold text-[#0e4d38] `}>Eligibility Criteria</h4>
                        <p>Intermediate / 10+2  with Commerce from a recognized Board/ University./ MDU Entrance Examination.</p>
                    </div>
                    </div>

            {/* table */}
            <div className="flex flex-col mb-[100px] ">
                <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
                    <div className="inline-block min-w-full py-2 sm:px-6 lg:px-8">
                    <div className="overflow-hidden">
                        <table className="min-w-full text-center text-sm font-light">
                        <thead
                            className="border-b bg-[#23376c] font-medium text-white rounded-md ">
                            <tr>
                            <th scope="col" className=" px-6 py-4">Programme</th>
                            <th scope="col" className=" px-6 py-4">Branch/ Specialization</th>
                            <th scope="col" className=" px-6 py-4">Duration (Years)</th>
                            <th scope="col" className=" px-6 py-4">No. of Seats</th>
                            {/* <th scope="col" className=" px-6 py-4">One time Charges including Registration</th>
                            <th scope="col" className=" px-6 py-4">Yearly Fee (All India Quota)</th>
                            <th scope="col" className=" px-6 py-4">Yearly Fee (UK Domicile)</th> */}
                            </tr>
                        </thead>
                        <tbody>
                            <tr className="border-b dark:border-neutral-500">
                            <td className="whitespace-nowrap  px-6 py-4 font-semibold ">Bachelor of Commerce</td>
                            <td className="whitespace-nowrap  px-6 py-4">Core</td>
                            <td className="whitespace-nowrap  px-6 py-4">3</td>
                            <td className="whitespace-nowrap  px-6 py-4">60</td>
                            {/* <td className="whitespace-nowrap  px-6 py-4">Rs.16000/-</td>
                            <td className="whitespace-nowrap  px-6 py-4">Rs.60000/-</td>
                            <td className="whitespace-nowrap  px-6 py-4">Rs.45000/-</td> */}
                            </tr>
                            <tr className="border-b dark:border-neutral-500">
                            <td className="whitespace-nowrap  px-6 py-4 font-semibold ">Bachelor of Commerce with Hons. (B.Com. Hons.)</td>
                            <td className="whitespace-nowrap  px-6 py-4">Finance</td>
                            <td className="whitespace-nowrap  px-6 py-4">4</td>
                            <td className="whitespace-nowrap  px-6 py-4">20</td>
                            <td className="whitespace-nowrap  px-6 py-4">Rs.16000/-</td>
                            <td className="whitespace-nowrap  px-6 py-4">Rs.60000/-</td>
                            <td className="whitespace-nowrap  px-6 py-4">Rs.45000/-</td>
                            </tr>
                            <tr className="border-b dark:border-neutral-500">
                            <td className="whitespace-nowrap  px-6 py-4 font-semibold ">Bachelor of Commerce with Hons. (B.Com. Hons.)</td>
                            <td className="whitespace-nowrap  px-6 py-4">Taxation</td>
                            <td className="whitespace-nowrap  px-6 py-4">4</td>
                            <td className="whitespace-nowrap  px-6 py-4">20</td>
                            <td className="whitespace-nowrap  px-6 py-4">Rs.16000/-</td>
                            <td className="whitespace-nowrap  px-6 py-4">Rs.60000/-</td>
                            <td className="whitespace-nowrap  px-6 py-4">Rs.45000/-</td>
                            </tr>
                            <tr className="border-b dark:border-neutral-500">
                            <td className="whitespace-nowrap  px-6 py-4 font-semibold ">Bachelor of Commerce with Hons. (B.Com. Hons.)</td>
                            <td className="whitespace-nowrap  px-6 py-4">Accounting</td>
                            <td className="whitespace-nowrap  px-6 py-4">4</td>
                            <td className="whitespace-nowrap  px-6 py-4">20</td>
                            <td className="whitespace-nowrap  px-6 py-4">Rs.16000/-</td>
                            <td className="whitespace-nowrap  px-6 py-4">Rs.60000/-</td>
                            <td className="whitespace-nowrap  px-6 py-4">Rs.45000/-</td>
                            </tr>

                
                        </tbody>
                        </table>
                    </div>
                    </div>
                </div>
                </div>


        </div>
        <Footer/>
    </div>
  )
}

export default BachelorCommerce